import * as types from '../mutations'
import Vue from 'vue'
import axios from 'axios'

const state = {
    artists: [],
    artistsFetched: false,
}

function findById(id, arr)
{
    for (let i = 0; i < arr.length; ++i)
    {
        if (arr[i].id === id)
        {
            return { index: i, obj: arr[i]}
        }
    }
    return null
}

const mutations = {

    [types.ARTIST_FETCH] (state, list)
    {
        state.artists = list
        state.artistsFetched = true
    },

    [types.ARTIST_ADD] (state, artist)
    {
        state.artists.push(artist)
    },

    [types.ARTIST_DELETE] (state, artist)
    {
        const result = findById(artist.id, state.artists)
        if (result)
        {
            state.artists.splice(result.index, 1)
        }
    },

    [types.ARTIST_UPDATE] (state, artist)
    {
        const result = findById(artist.id, state.artists)
        if (result)
        {
            Vue.set(state.artists, result.index, artist)
        }
    },

}

const actions = {

    init({rootGetters, dispatch})
    {
        /*
        if (rootGetters.authLoggedIn)
            dispatch('artistCheck')
        */
    },

    artistCheck({dispatch, state})
    {
        if (!state.artistsFetched)
        {
            dispatch('artistFetch')
        }
    },

    artistFetch({commit})
    {
        return new Promise(async(resolve, reject) => {
            const list = await axios.get(process.env.API_URL + '/v1/admin/artists')
            if (list)
            {
                commit(types.ARTIST_FETCH, list.data)
                resolve(list.data)
            } else {
                reject()
            }
        })
    },

    artistUpdate({commit}, artist)
    {
        return new Promise((resolve, reject) => {
            commit(types.ARTIST_UPDATE, artist)
            resolve()
        })
    },

    artistDelete({commit}, artist)
    {
        return new Promise((resolve, reject) => {
            commit(types.ARTIST_DELETE, artist)
            resolve()
        })
    },

    artistNew({commit}, artist)
    {
        return new Promise((resolve, reject) => {
            commit(types.ARTIST_ADD, artist)
            resolve()
        })
    },

}

const getters = {
    artistList: state => JSON.parse(JSON.stringify(state.artists))
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/artist.js